import toast from 'react-hot-toast';
import React, { memo, useCallback, useEffect } from 'react'
import questionnaire from '../../../questionnaire'
import { checkElement, getConformSelector, questionOneChoice } from '../../../utils';
import { FormCard } from '../../FormCard';
import Checkbox from '../Checkbox';
import Footer from '../Footer';
import TableQuestion from '../TableQuestion';
import { useDispatch, useSelector } from 'react-redux';
import { selectorQuiz, updateQuiz } from '../../../features/quiz/quizSlice';
import ToastAction from '../../ToastAction';
const { section3 } = questionnaire

const { question7, question8, question9 } = section3.questions

const mapQuestionsIds = {}

question7.answers.forEach(ans => {
  mapQuestionsIds[ans] = getConformSelector(ans)
})
question8.answers.forEach(ans => {
  mapQuestionsIds[ans] = getConformSelector(ans)
})

function Step2(props) {
  const dispatch = useDispatch()
  const quiz = useSelector(selectorQuiz)
  const activeWebsite = useSelector(state => state.websites.activeWebsite)

  useEffect(() => {
    checkElement(`#${mapQuestionsIds[quiz.question7]}-choice_question7`)
    checkElement(`#${mapQuestionsIds[quiz.question8]}-choice_question8`)
  }, [])

  useEffect(() => {
    props.firstStep()
  }, [activeWebsite])

  const onSubmit = useCallback((e) => {
    e.preventDefault()

    if (!quiz.question7) return toast.custom((t) => <ToastAction saraExpression="worried" toastRef={t} label="Question7 requise !" description="Veuillez selectionner un choix sur la question7." />)
    if (!quiz.question8) return toast.custom((t) => <ToastAction saraExpression="worried" toastRef={t} label="Question8 requise !" description="Veuillez selectionner un choix sur la question8." />)

    if (window.innerWidth < 768) {
      const answerQuestion9A = questionOneChoice(e.target, 40, 44, question9.answers, false)

      if (answerQuestion9A.trim() === '') return toast.custom((t) => <ToastAction saraExpression="worried" toastRef={t} label="Rubrique requise !" description="Veuillez selectionner un choix sur la rubrique: Evaluer si cet outil est utile pour mon entreprise." />)

      const answerQuestion9B = questionOneChoice(e.target, 45, 49, question9.answers, false)
      if (answerQuestion9B.trim() === '') return toast.custom((t) => <ToastAction saraExpression="worried" toastRef={t} label="Rubrique requise !" description="Veuillez selectionner un choix sur la rubrique: Choisir l'outil à mettre en place." />)

      const answerQuestion9C = questionOneChoice(e.target, 50, 54, question9.answers, false)

      if (answerQuestion9C.trim() === '') return toast.custom((t) => <ToastAction saraExpression="worried" toastRef={t} label="Rubrique requise !" description="Veuillez selectionner un choix sur la rubrique: Apprendre à me servir de l'outil." />)

      const answerQuestion9D = questionOneChoice(e.target, 55, 59, question9.answers, false)

      if (answerQuestion9D.trim() === '') return toast.custom((t) => <ToastAction saraExpression="worried" toastRef={t} label="Rubrique requise !" description="Veuillez selectionner un choix sur la rubrique: Financer ce projet." />)

      const answerQuestion9E = questionOneChoice(e.target, 60, 64, question9.answers, false)

      if (answerQuestion9E.trim() === '') return toast.custom((t) => <ToastAction saraExpression="worried" toastRef={t} label="Rubrique requise !" description="Veuillez selectionner un choix sur la rubrique: Trouver le professionnel ou l'entreprise pour installer l'outil." />)

      const answerQuestion9F = questionOneChoice(e.target, 65, 69, question9.answers, false)

      if (answerQuestion9F.trim() === '') return toast.custom((t) => <ToastAction saraExpression="worried" toastRef={t} label="Rubrique requise !" description="Veuillez selectionner un choix sur la rubrique: Trouver le temps de me servir de l'outil moi-même une fois mis en place." />)
      const _question9 = {
        [e.target[41].name]: answerQuestion9A,
        [e.target[46].name]: answerQuestion9B,
        [e.target[51].name]: answerQuestion9C,
        [e.target[56].name]: answerQuestion9D,
        [e.target[61].name]: answerQuestion9E,
        [e.target[66].name]: answerQuestion9F
      }

      if (JSON.stringify(quiz.question9) !== JSON.stringify(_question9)) dispatch(updateQuiz({ question9: _question9 }))

      window.scrollTo(0, 0)
      props.nextStep()
    } else {
      const answerQuestion9A = questionOneChoice(e.target, 10, 14, question9.answers, false)
      if (answerQuestion9A.trim() === '') return toast.custom((t) => <ToastAction saraExpression="worried" toastRef={t} label="Rubrique requise !" description="Veuillez selectionner un choix sur la rubrique: Evaluer si cet outil est utile pour mon entreprise." />)

      const answerQuestion9B = questionOneChoice(e.target, 15, 19, question9.answers, false)
      if (answerQuestion9B.trim() === '') return toast.custom((t) => <ToastAction saraExpression="worried" toastRef={t} label="Rubrique requise !" description="Veuillez selectionner un choix sur la rubrique: Choisir l'outil à mettre en place." />)

      const answerQuestion9C = questionOneChoice(e.target, 20, 24, question9.answers, false)
      if (answerQuestion9C.trim() === '') return toast.custom((t) => <ToastAction saraExpression="worried" toastRef={t} label="Rubrique requise !" description="Veuillez selectionner un choix sur la rubrique: Apprendre à me servir de l'outil." />)

      const answerQuestion9D = questionOneChoice(e.target, 25, 29, question9.answers, false)
      if (answerQuestion9D.trim() === '') return toast.custom((t) => <ToastAction saraExpression="worried" toastRef={t} label="Rubrique requise !" description="Veuillez selectionner un choix sur la rubrique: Financer ce projet." />)

      const answerQuestion9E = questionOneChoice(e.target, 30, 34, question9.answers, false)
      if (answerQuestion9E.trim() === '') return toast.custom((t) => <ToastAction saraExpression="worried" toastRef={t} label="Rubrique requise !" description="Veuillez selectionner un choix sur la rubrique: Trouver le professionnel ou l'entreprise pour installer l'outil." />)

      const answerQuestion9F = questionOneChoice(e.target, 35, 39, question9.answers, false)
      if (answerQuestion9F.trim() === '') return toast.custom((t) => <ToastAction saraExpression="worried" toastRef={t} label="Rubrique requise !" description="Veuillez selectionner un choix sur la rubrique: Trouver le temps de me servir de l'outil moi-même une fois mis en place." />)
      const _question9 = {
        [e.target[11].name]: answerQuestion9A,
        [e.target[16].name]: answerQuestion9B,
        [e.target[21].name]: answerQuestion9C,
        [e.target[26].name]: answerQuestion9D,
        [e.target[31].name]: answerQuestion9E,
        [e.target[36].name]: answerQuestion9F
      }

      if (JSON.stringify(quiz.question9) !== JSON.stringify(_question9)) dispatch(updateQuiz({ question9: _question9 }))

      props.nextStep()
    }
  }, [quiz.question7, quiz.question8])


  return (
    <form onSubmit={onSubmit}>
      <section className={`section-questions`}>
        <FormCard title='PROFIL DIGITAL'>
          <div className='mb-10'>
            <h4 className='question'>{question7.label}</h4>
            {question7.answers.map((answer, key) => <Checkbox key={key} type='radio' option={answer} name='choice_question7' idEl={mapQuestionsIds[answer]} />)}
          </div>
          <div className='mb-10'>
            <h4 className='question'>{question8.label}</h4>
            {question8.answers.map((answer, key) => <Checkbox key={key} type='radio' option={answer} name='choice_question8' idEl={mapQuestionsIds[answer]} />)}
          </div>
          <h4 className='question'>{question9.label}</h4>
          {!quiz.loading && <TableQuestion question={question9} quiz={quiz} />}
        </FormCard>
      </section>
      <Footer {...props} />
    </form>
  )
}

export default memo(Step2)